export const serialize = (params: Record<string, any>) => {
  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    if (Array.isArray(value)) {
      for (const element of value) {
        searchParams.append(key, String(element));
      }
    } else {
      searchParams.append(key, String(value));
    }
  }

  return searchParams.toString();
};
